"use client";
import type { ReactElement } from 'react';
import { AuthModalState } from '@/types/auth-types';
import { ActivationCompleteAuthBody } from './ActivationCompleteAuthBody';
import { EmailSentAuthBody } from './EmailSentAuthBody';
import { ErrorAuthBody } from './ErrorAuthBody';
import { InitialAuthBody } from './InitialAuthBody';
import type { CauthmodalState } from './useCauthmodalState';
interface CauthmodalContentProps {
    onClose?: () => void;
    state: CauthmodalState;
}
export function CauthmodalContent({ onClose, state, }: CauthmodalContentProps): ReactElement {
    const modalContentByState: Record<AuthModalState, ReactElement> = {
        [AuthModalState.EmailSent]: (<EmailSentAuthBody email={state.email} onRetry={state.handleRetry}/>),
        [AuthModalState.ActivationComplete]: (<ActivationCompleteAuthBody onClose={onClose}/>),
        [AuthModalState.Error]: (<ErrorAuthBody error={state.error} onRetry={state.handleRetry}/>),
        [AuthModalState.Initial]: (<InitialAuthBody email={state.email} emailInputError={state.emailInputError} loadingApple={state.loadingApple} loadingGoogle={state.loadingGoogle} loadingEmail={state.loadingEmail} onAppleAuth={state.handleAppleAuth} onGoogleAuth={state.handleGoogleAuth} onEmailAuth={state.handleEmailAuth} onEmailChange={state.handleEmailChange} onOpenTerms={state.handleOpenTerms} onPrivacyClick={state.handlePrivacyClick}/>),
    };
    return (
      <div data-el="Cauthmodal/Content/Root" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
        }}>
        {modalContentByState[state.modalState]}
      </div>
    );
}
